import type { FormOptions } from "../../types/forms";

export const advancedKeys = ["customer_id", "created_by", "date_from", "date_to"] as const;
export type AdvancedFormFilters = Record<(typeof advancedKeys)[number], string>;
export interface FormFilterProps {
  params: URLSearchParams;
  options: FormOptions | null;
  customerId?: number;
  onChange: (key: string, value: string) => void;
  onApply: (values: AdvancedFormFilters) => void;
  onClear: () => void;
}
